<template>
    <a-modal
        :visible="visible"
        title="Else Aksiyonları Düzenle"
        width="800px"
        @cancel="onCancel"
        @ok="onSave"
        okText="Kaydet"
        cancelText="İptal"
        :bodyStyle="{ padding: '24px' }"
    >
        <div class="else-actions-editor">
            <p class="description">
                Hiçbir kural eşleşmediğinde çalışacak varsayılan aksiyonları tanımlayın
            </p>

            <ActionsEditor
                v-model="localActions"
                when-type="contact_created"
            />
        </div>
    </a-modal>
</template>

<script>
import ActionsEditor from "./ActionsEditor.vue";
import log2 from "../../../../../../utils/log2";

const log = log2("ElseActionsEditor");

export default {
    name: "ElseActionsEditor",
    components: {
        ActionsEditor
    },
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        actions: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            localActions: []
        };
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.localActions = JSON.parse(JSON.stringify(this.actions));
            }
        }
    },
    created() {
        this.localActions = JSON.parse(JSON.stringify(this.actions));
    },
    methods: {
        onCancel() {
            this.$emit("close");
        },

        onSave() {
            this.$emit("save", this.localActions);
        }
    }
};
</script>

<style lang="scss" scoped>
.else-actions-editor {
    .description {
        color: #666;
        margin-bottom: 24px;
        padding: 12px;
        background: #f5f5f5;
        border-left: 3px solid #1890ff;
        border-radius: 4px;
    }
}
</style>

